import type { ResourceContentstackContentPackageType } from '@csp/csp-common-content-definitions';
import type { UnifyContentPackage } from '@csp/csp-common-content-models/src/lib/UnifyContentPackage';
import { ContentstackPackage } from '@csp/csp-common-content-models/src/lib/ContentstackPackage';
import { ResourceContentFactory } from '../utils/models/resource/ResourceContentFactory';

export const contentstackPackageToUnifyContentPackage = (contentPackage?: ContentstackPackage): UnifyContentPackage => {
  if (typeof contentPackage !== 'object') {
    return {};
  }
  const result: UnifyContentPackage = {};
  Object.keys(contentPackage).map(contentModelKey => {
    if (contentModelKey === 'resource') {
      result.resource = ResourceContentFactory.fromContentPackage(
        contentPackage as unknown as ResourceContentstackContentPackageType,
      ).resource;
    } else {
      result[contentModelKey] = contentPackage[contentModelKey] as ContentstackPackage[string];
    }
  });
  return result;
};
